import "react";
import { jsx as e, jsxs as t } from "react/jsx-runtime";
//#region src/components/atoms/Icon/SVGs/questionmark.svg
var n = (n) => /* @__PURE__ */ t("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 24 24",
	...n,
	children: [/* @__PURE__ */ e("g", {
		clipPath: "url(#clip0_9400_504)",
		children: /* @__PURE__ */ e("path", {
			fill: "#1f2830",
			d: "M12 0a12 12 0 1 0 0 24 12 12 0 0 0 0-24m0 19a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3m1.6-6.08a1 1 0 0 0-.6.92 1 1 0 0 1-2 0 3 3 0 0 1 1.8-2.75A2 2 0 1 0 10 9.25a1 1 0 1 1-2 0 4 4 0 1 1 5.6 3.67"
		})
	}), /* @__PURE__ */ e("defs", { children: /* @__PURE__ */ e("clipPath", {
		id: "clip0_9400_504",
		children: /* @__PURE__ */ e("rect", {
			width: 24,
			height: 24,
			fill: "#fff"
		})
	}) })]
});
//#endregion
export { n as default };
